import {twMerge} from "tailwind-merge";

export default function NumberInput({classes = {}, value, onChange, min = 1, max, ...otherProps}) {

    const {parentClasses = "", inputClasses} = classes;

    const changeHandler = (increase) => {
        if (increase) {
            if (!max || value + 1 <= max) {
                onChange(value + 1)
            }
        } else {
            if (value - 1 >= min) {
                onChange(value - 1)
            }
        }
    }

    return (
        <div
            className={twMerge("bg-pol-light-3 rounded-[0.875rem] border border-pol-light-4 flex-between gap-x-3 px-3.5 w-[12.625rem] text-pol-gray", parentClasses)}>
            <button
                type="button"
                onClick={changeHandler}
            >
                <i className="icon-plus text-sm"/>
            </button>
            <input
                className={twMerge("focus:outline-none text-center flex-grow py-2.5", inputClasses)}
                value={value}
                inputMode="numeric"
                type="number"
                onChange={({target}) => onChange(target.value)}
                {...otherProps}
            />
            <button
                type="button"
                onClick={() => changeHandler(0)}
            >
                <i className="icon-minus text-[0.188rem]"/>
            </button>
        </div>
    )
}
